import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';
import {AuthService} from 'app/core/auth/auth.service';
import {of, switchMap} from 'rxjs';
import {UtilsService} from "../../../api/services/utils.service";

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                } else {
                    if (UtilsService.isFreeUser()) {
                        const isPricingRoute = router.getCurrentNavigation().finalUrl?.toString() === '/user/pricing';
                        const isPurchaseConfirmationRoute = router.getCurrentNavigation().finalUrl?.toString().includes('/user/purchaseconfirmation');
                        const isPurchaseErrorRoute = router.getCurrentNavigation().finalUrl?.toString().includes('/user/purchaseerror');
                        const isSignOut = router.getCurrentNavigation().finalUrl?.toString().includes('/sign-out');

                        if (!isPricingRoute
                            && !isPurchaseConfirmationRoute
                            && !isPurchaseErrorRoute
                            && !isSignOut) {
                            const urlTree = router.parseUrl(`/user/pricing`);
                            return of(urlTree);
                        }
                    }
                }

                // Allow the access
                return of(true);
            })
        );
};
